/**
 * Partner Slider
 *
 * Desktop: 4 Logos
 * Tablet:  3 Logos
 * Mobile:  2 Logos
 */
(function () {
  var sliders = new Map();

  function visibleItems() {
    if (window.matchMedia('(min-width: 1024px)').matches) return 4;
    if (window.matchMedia('(min-width: 640px)').matches) return 3;
    return 2;
  }

  function initSlider(slider) {
    var track = slider.querySelector('[data-partner-track]');
    var prevButton = slider.querySelector('[data-partner-prev]');
    var nextButton = slider.querySelector('[data-partner-next]');
    var previous = sliders.get(slider);

    if (previous) {
      if (previous.track === track && previous.prevButton === prevButton && previous.nextButton === nextButton) {
        previous.update();
        return;
      }
      previous.destroy();
      sliders.delete(slider);
    }

    if (!track || !prevButton || !nextButton) return;

    var currentIndex = 0;
    var resizeFrame = null;
    var animation = null;
    var pendingIndex = null;

    function items() {
      return Array.from(track.querySelectorAll('[data-partner-item]'));
    }

    function finishAnimation() {
      if (!animation) return;
      animation.onfinish = null;
      animation.cancel();
      animation = null;
      currentIndex = pendingIndex;
      pendingIndex = null;
    }

    function update() {
      finishAnimation();
      var visible = visibleItems();
      var partnerItems = items();
      var count = partnerItems.length;
      currentIndex = count > visible ? ((currentIndex % count) + count) % count : 0;

      // Zyklisch anordnen, ohne DOM-Knoten zu verschieben oder Neos-/Bild-IDs zu klonen.
      partnerItems.forEach(function (item, index) {
        item.style.order = String((index - currentIndex + count) % count);
      });
      track.style.transform = 'translate3d(0, 0, 0)';
      track.style.justifyContent = count <= visible ? 'center' : 'flex-start';

      var navigationNeeded = count > visible;
      prevButton.disabled = !navigationNeeded;
      nextButton.disabled = !navigationNeeded;
    }

    function move(direction) {
      // Ein weiterer Klick beendet den vorigen Schritt und schaltet genau einmal weiter.
      update();
      var count = items().length;
      var visible = visibleItems();
      if (count <= visible) return;

      var nextIndex = (currentIndex + direction + count) % count;
      if (typeof track.animate !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        currentIndex = nextIndex;
        update();
        return;
      }

      var origin = 'translate3d(0, 0, 0)';
      var offset = 'translate3d(-' + (100 / visible) + '%, 0, 0)';
      if (direction < 0) {
        // Das vorangehende Logo steht zunächst links außerhalb des sichtbaren Fensters.
        currentIndex = nextIndex;
        update();
      }

      pendingIndex = nextIndex;
      animation = track.animate([
        { transform: direction > 0 ? origin : offset },
        { transform: direction > 0 ? offset : origin }
      ], { duration: 300, easing: 'ease-out', fill: 'forwards' });
      animation.onfinish = update;
    }

    function previousItem() {
      move(-1);
    }

    function nextItem() {
      move(1);
    }

    function resize() {
      if (resizeFrame !== null) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = null;
        update();
      });
    }

    prevButton.addEventListener('click', previousItem);
    nextButton.addEventListener('click', nextItem);
    window.addEventListener('resize', resize);

    sliders.set(slider, {
      track: track,
      prevButton: prevButton,
      nextButton: nextButton,
      update: update,
      destroy: function () {
        prevButton.removeEventListener('click', previousItem);
        nextButton.removeEventListener('click', nextItem);
        window.removeEventListener('resize', resize);
        if (resizeFrame !== null) cancelAnimationFrame(resizeFrame);
        finishAnimation();
        items().forEach(function (item) { item.style.removeProperty('order'); });
      }
    });

    slider.setAttribute('data-partner-slider-initialized', 'true');
    update();
  }

  function init() {
    sliders.forEach(function (state, slider) {
      if (!slider.isConnected) {
        state.destroy();
        sliders.delete(slider);
      }
    });
    document.querySelectorAll('[data-partner-slider]').forEach(initSlider);
  }

  function start() {
    init();
    // Neos ersetzt Inhalte beim Inline-Editing; neue und geänderte Boxen erneut erfassen.
    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
